import { z } from 'zod';

export const orderNoteSchema = z.object({
  message: z
    .string()
    .trim()
    .min(1, { error: 'orders:addNote.validation.messageRequired' })
    .max(2000, { error: 'orders:addNote.validation.messageLength' }),
  visibleToCustomer: z.boolean(),
});

export type OrderNoteFormInput = z.input<typeof orderNoteSchema>;
export type OrderNoteFormOutput = z.output<typeof orderNoteSchema>;
